export const getQueryParamsForFindEntity = (token) => {
    if(token.value) {
        switch(token.propertyKey) {
            case "pipelineName":
                return "pipeline="+token.value;
            case "stackName":
                return "stack="+token.value;
            default:
                return "name="+token.value;     
        }
    }
    return;
}

export const getRedirectUrlForSearch = (token) => {
	if (token.value && token.propertyKey === 'workflowId') {
		return '#/entitySearch?workflowType=' + encodeURIComponent(token.value);
	}

	const queryParams = getQueryParamsForFindEntity(token);

	if (queryParams) {
		return '#/findEntity?' + queryParams;
	}

};
